import { Link } from './Link';

export type { TypeLinkProps } from './types';
export default Link;
